<div class="task-message-modal-move-dialog-container">
  <div class="modal-header">
    <div class="modal-header-title">{{ 'coordination-case-credit-title' | translate }}</div>
    <div class="modal-buttons">
      <div (click)="activeModal.dismiss('Credit cancelled')">
        <img src="/assets/icons/Close White.svg" alt="Close window button"/>
      </div>
    </div>
  </div>

  <div class="modal-content-body">
    <div class="input-text-header">
      <div class="modal-text">
        {{ 'coordination-case-credit-header' | translate }}
      </div>
    </div>

    <app-drop-down [items]="invoiceItems"
                   [disabled]=false
                   (selectedItemIdChange)="serviceItemChange($event)"
                   [(selectedItemId)]="selectedInvoiceItem"/>

    <div class="button-container-row">
      <button class="modal-button" (click)="creditICCSupplier()" [disabled]="!isCreditButtonEnabled()">
        {{ 'coordination-case-credit-button-title' | translate }}
      </button>
    </div>
  </div>
</div>
